import { Component, Input, OnInit } from '@angular/core';
import { Property } from '@smartflip/data-models';
import { Router } from '@angular/router';
import { propertyCategories } from '@smartflip/data-constants';
import { IonicModule } from '@ionic/angular';
import { PropertyImageComponent } from 'libs/features/shared/components/src/lib/property-image/property-image.component';

@Component({
  selector: 'app-home-list-card',
  templateUrl: './home-list-card.component.html',
  styleUrls: ['./home-list-card.component.scss'],
  imports: [IonicModule, PropertyImageComponent],
})
export class HomeListCardComponent implements OnInit {
  @Input() property: Property;
  @Input() category: string;

  public cats = propertyCategories;
  public noCategoryMessage: string;

  ngOnInit() {
    this.noCategoryMessage = `You have no ${this.category} properties. ${this.cats[this.category].howToAdd} to get started.`;
  }

  constructor(private router: Router) {}

  navigateToProperty(propertyId: string) {
    this.router.navigate(['/property', propertyId]);
  }
}
